export default __webpack_public_path__ + "static/media/foundry.da5155f8.png";